export default __webpack_public_path__ + "static/media/feedback-img.86cf74a5.png";